module.exports = __webpack_public_path__ + "img/HU10325737.9c8e57e2.png";